export default "__VITE_ASSET__ibbtTO$U__"